<div
  class="bg-night text-white max-h-[90vh] overflow-hidden flex flex-col"
  data-testid="recent-orders-dialog">
  <div class="p-4 lg:p-6 border-b border-white/10 flex items-center justify-between">
    <h2 class="text-xl font-bold flex items-center gap-3">
      <span class="material-symbols-outlined text-neon">history</span>
      {{ 'pos.recent_orders.title' | translate }}
    </h2>
    <button
      type="button"
      (click)="close()"
      class="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <div class="flex-1 overflow-y-auto p-4 lg:p-6">
    @if (!hasOrders()) {
      <div class="flex flex-col items-center justify-center py-12 text-white/40">
        <span class="material-symbols-outlined text-5xl mb-4">receipt_long</span>
        <p class="text-sm">{{ 'pos.recent_orders.no_orders' | translate }}</p>
      </div>
    } @else {
      <div class="space-y-3">
        @for (order of recentOrders(); track order.id) {
          <div
            class="rounded-xl border p-4"
            data-testid="recent-order-item"
            [ngClass]="{
              'bg-red-500/5 border-red-500/20': order.isOverhead,
              'bg-blue-500/5 border-blue-500/20': order.isTab && !order.isOverhead,
              'bg-white/5 border-white/10': !order.isOverhead && !order.isTab,
            }">
            <div class="flex items-center justify-between mb-3">
              <div class="flex items-center gap-2 flex-wrap">
                <span
                  class="material-symbols-outlined text-lg"
                  [ngClass]="{
                    'text-red-400': order.isOverhead,
                    'text-blue-400': order.isTab && !order.isOverhead,
                    'text-neon': !order.isOverhead && !order.isTab,
                  }">
                  @if (order.isOverhead) {
                    trending_down
                  } @else if (order.isTab) {
                    receipt_long
                  } @else {
                    shopping_bag
                  }
                </span>
                <span class="text-xs text-white/50">{{ order.createdAt | date: 'HH:mm:ss' }}</span>
                @if (order.cashierName) {
                  <span class="text-xs text-white/30">{{ order.cashierName }}</span>
                }
                @if (order.isOverhead) {
                  <span class="px-2 py-0.5 rounded-full bg-red-500/20 text-red-400 text-xs">
                    {{ 'pos.checkout.overhead' | translate }}
                  </span>
                } @else if (order.isTab) {
                  <span class="px-2 py-0.5 rounded-full bg-blue-500/20 text-blue-400 text-xs">
                    {{ order.tabName || ('pos.recent_orders.tab_order' | translate) }}
                  </span>
                } @else if (order.paymentMethod) {
                  <span class="px-2 py-0.5 rounded-full bg-white/10 text-white/70 text-xs">
                    {{
                      order.paymentMethod === PaymentMethod.Cash
                        ? ('pos.checkout.cash' | translate)
                        : ('pos.checkout.card' | translate)
                    }}
                  </span>
                }
                @if (order.totalPoints > 0) {
                  <span class="px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-400 text-xs">
                    {{ order.totalPoints }} {{ 'pos.checkout.points' | translate | lowercase }}
                  </span>
                }
              </div>
              <span
                class="text-lg font-bold"
                [ngClass]="{
                  'text-red-400': order.isOverhead,
                  'text-white': !order.isOverhead,
                }">
                {{ order.totalCents / 100 | number: '1.2-2' }} €
              </span>
            </div>
            <div class="space-y-1">
              @for (item of order.items; track $index) {
                <div class="flex items-center justify-between text-sm">
                  <span class="text-white/70"
                    >{{ item.productName }} <span class="text-white/50">x{{ item.qty }}</span></span
                  >
                  @if (item.paymentType === PaymentType.Points) {
                    <span class="text-amber-400"
                      >{{ item.pricePoints }} {{ 'pos.checkout.points' | translate | lowercase }}</span
                    >
                  } @else {
                    <span class="text-white/50">{{ item.priceCents / 100 | number: '1.2-2' }} €</span>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>

      @if (hasMore()) {
        <button
          type="button"
          class="w-full mt-4 py-3 text-sm font-medium text-white/60 hover:text-white/80 hover:bg-white/5 rounded-xl transition-colors flex items-center justify-center gap-2"
          [disabled]="loading()"
          (click)="loadMore()">
          @if (loading()) {
            <span class="material-symbols-outlined text-base animate-spin">progress_activity</span>
          } @else {
            <span class="material-symbols-outlined text-base">expand_more</span>
          }
          {{ 'common.showMore' | translate }}
        </button>
      }
    }
  </div>

  <div class="p-4 lg:p-6 border-t border-white/10">
    <button
      type="button"
      (click)="close()"
      class="w-full py-3 px-6 rounded-full border border-white/20 text-white font-medium hover:bg-white/10 transition-colors flex items-center justify-center gap-2">
      <span class="material-symbols-outlined">arrow_back</span>
      {{ 'pos.tabs.back' | translate }}
    </button>
  </div>
</div>
